import { Box, Skeleton } from '@mui/material';
import React from 'react';
import '../../styles/partenaireExpo.css';

/**
 * Skeleton for Exposant/Partenaire list items.
 * Mirrors the layout: rectangular logo (90×80), company name, domain, optional stand.
 * @param {number} count - Number of skeleton rows to show
 */
export function ExposantSkeleton({ count = 6 }) {
  return (
    <Box
      className="container-exposants"
      sx={{
        width: '100%',
        maxWidth: 576,
        mx: 'auto',
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          className="partenaire-item"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            gap: 1,
            pt: '15px',
            pb: 2,
            borderBottom: i < count - 1 ? '1px solid' : 'none',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant="rectangular" width={90} height={80} sx={{ flexShrink: 0, mr: 1.25 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="50%" height={20} />
          </Box>
          {i % 2 === 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
              <Skeleton variant="rectangular" width={24} height={24} />
              <Skeleton variant="text" width={40} height={20} />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
